import {
  DocumentationEdit,
  DocumentationList,
  DocumentationShow
} from 'pages/secretary/documentations';
import { generateResources } from 'utils/GenerateResouces';

const resource = {
  name: 'documentations',
  label: 'Documentações',
  list: DocumentationList,
  edit: DocumentationEdit,
  show: DocumentationShow,
  actions: ['list', 'create', 'edit', 'show'],
  parentName: 'secretary'
};

export default generateResources(resource);
